import axios from 'axios';
// import { useAuth } from '../hooks/useAuth';


let isRedirecting = false;


class API {
  constructor() {
    // Cria instância base do axios com a URL da API
    const baseURL = process.env.REACT_APP_URL_BASE_BACKEND;

    this.api = axios.create({
      baseURL,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    // Intercepta as requisições para incluir o token de autenticação
    this.api.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('authToken');

        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    // Intercepta respostas para tratar erros globais (ex: token expirado)
    this.api.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error.response?.status;

        // 402 fica de fora de proposito: e o bloqueio por plano, tratado
        // pela tela de planos. Incluir 402 aqui deslogaria quem so precisa
        // fazer upgrade.
        if ((status === 401 || status === 403) && !isRedirecting) {
          isRedirecting = true;
          console.warn('JWT expirado ou inválido. Redirecionando para o Login');

          localStorage.removeItem('authToken');
          localStorage.removeItem('user');
          localStorage.removeItem('selectedWorkspaceId');

          if (!window.location.pathname.includes('/login')) {
            window.location.href = '/login?expired=true';
          }
        }

        return Promise.reject(error);
      }
    );
  }

  // Métodos genéricos para facilitar o uso
  get(endpoint, config = {}) {
    return this.api.get(endpoint, config);
  }

  post(endpoint, data, config = {}) {
    return this.api.post(endpoint, data, config);
  }

  put(endpoint, data, config = {}) {
    return this.api.put(endpoint, data, config);
  }

  patch(endpoint, data = {}, config = {}) {
    return this.api.patch(endpoint, data, config);
  }

  delete(endpoint, config = {}) {
    return this.api.delete(endpoint, config);
  }
}

const api = new API(); // Instância única da classe API
export default api;
